import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/idiegti/IdiegtiClient.tsx");
